import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M47.07 14.94c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#0597A3"
      d="M78.19 22.9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M31.58 95a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      d="m9.69 80.6 3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM101.51 91.17h-5.57V85.6c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M91.38 46.97c1.48-.34 2.55-1.6 2.55-3.12v-6.97c0-1.76-1.43-3.19-3.19-3.19H24.61c-1.4 0-2.54 1.14-2.54 2.54v8.14c0 1.21.85 2.27 2.04 2.48 5.24.96 9.2 5.54 9.2 11.05s-3.97 10.1-9.2 11.05c-1.19.22-2.03 1.28-2.03 2.48v8.32c0 1.4 1.14 2.54 2.54 2.54h66.13c1.76 0 3.19-1.43 3.19-3.19v-7.14c0-1.51-1.08-2.78-2.55-3.12a11.24 11.24 0 0 1-8.69-10.95c0-5.33 3.71-9.79 8.69-10.95z"
      clipRule="evenodd"
    />
    <path
      fill="#001A43"
      d="M76.57 49.07H54.55c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h22.02c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M76.57 60.46H54.55c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h22.02c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M76.57 71.85H54.55c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h22.02c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25"
    />
    <mask
      id="enrichedIcon-RebatesInverted_svg__a"
      width={72}
      height={50}
      x={22}
      y={33}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M91.38 46.97c1.47-.34 2.55-1.6 2.55-3.12v-6.97c0-1.76-1.43-3.19-3.19-3.19H24.61c-1.4 0-2.54 1.14-2.54 2.54v8.14c0 1.21.85 2.27 2.03 2.48 5.24.96 9.2 5.54 9.2 11.05S29.33 68 24.1 68.95c-1.19.22-2.03 1.28-2.03 2.48v8.32c0 1.4 1.14 2.54 2.54 2.54h66.13c1.76 0 3.19-1.43 3.19-3.19v-7.14c0-1.51-1.08-2.78-2.55-3.12a11.24 11.24 0 0 1-8.69-10.95c0-5.33 3.71-9.79 8.69-10.95z"
      />
    </mask>
    <g mask="url(#enrichedIcon-RebatesInverted_svg__a)">
      <path
        fill="#0597A3"
        d="M46.57 87.23c-.72 0-1.43-.35-1.86-.99l-3-4.43a2.23 2.23 0 0 1 0-2.52l2.15-3.17-2.15-3.17a2.23 2.23 0 0 1 0-2.52l2.14-3.16-2.14-3.16c-.52-.76-.52-1.76 0-2.53l2.14-3.16-2.14-3.16c-.52-.76-.52-1.76 0-2.53l2.14-3.16-2.14-3.16c-.52-.76-.52-1.76 0-2.53l2.14-3.16-2.14-3.16c-.52-.76-.52-1.76 0-2.53l3-4.42a2.253 2.253 0 1 1 3.73 2.53l-2.14 3.15 2.14 3.16c.52.76.52 1.76 0 2.53l-2.14 3.16 2.14 3.16c.52.76.52 1.76 0 2.53l-2.14 3.16 2.14 3.16c.52.76.52 1.76 0 2.53l-2.14 3.16L48.44 66c.52.76.52 1.76 0 2.53l-2.14 3.16 2.14 3.17c.52.76.52 1.76 0 2.52l-2.15 3.17 2.15 3.17c.7 1.03.43 2.43-.6 3.12-.39.26-.83.39-1.26.39z"
      />
    </g>
  </svg>
);
const SvgEnrichedIconRebatesInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconRebatesInverted);
export default Memo;
